module.exports = __webpack_public_path__ + "static/img/icon-eva4.6e66f1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-eva4.jpg
// module id = uuy4
// module chunks = 21